import "./index.html"
import "./style.scss"
import "./script.js"
